import { createFileRoute } from '@tanstack/react-router';

import { DispatchNew } from '../modules/ComponentsLibrary/Dispatch/DispatchNew';

export const Route = createFileRoute('/dispatch-new')({
  component: RouteComponent,
  head(ctx) {
    return {
      meta: [{ title: 'Dispatch' }],
    };
  },
});

function RouteComponent() {
  return <DispatchNew />;
}
